var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal_organization",
          attrs: {
            id: "modal-organization",
            title: _vm.title,
            size: "xl",
            "modal-class": "custom-modal",
            lazy: "",
            centered: "",
            scrollable: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          },
          on: { hidden: _vm.onHidden },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "w-100 d-flex justify-content-end" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-secondary mr-2",
                          on: { click: _vm.handleCancel }
                        },
                        [_vm._v("\n          Отменить\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-primary",
                          attrs: { disabled: _vm.isDisabled || _vm.loading },
                          on: { click: _vm.handleOk }
                        },
                        [
                          _vm.loading
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : _vm._e(),
                          _vm._v("\n          Сохранить\n        ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("b-skeleton-wrapper", {
            attrs: { loading: _vm.isBusy },
            scopedSlots: _vm._u([
              {
                key: "loading",
                fn: function() {
                  return [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-card",
                          { attrs: { "bg-variant": "light" } },
                          [
                            _c(
                              "b-row",
                              { staticClass: "mt-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "10%", height: "24%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "41%" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "10%", height: "24%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "41%" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "10%", height: "24%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "41%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      attrs: { width: "16%", height: "115%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "20%", height: "17%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "29%"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { width: "30%", height: "13%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "15%", height: "17%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "29%"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { width: "26%", height: "13%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "4%", height: "26%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "41%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "6%", height: "26%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "41%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-5" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "9%", height: "26%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "104%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-1" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      attrs: { width: "15%", height: "55%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "6%", height: "26%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "41%" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "49%", height: "26%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "41%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-3" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "19%", height: "26%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "41%" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "28%", height: "26%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "41%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-0" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "35%", height: "50%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "43%", height: "21%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "50%" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "26%", height: "21%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "50%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "30%", height: "21%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "50%" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "20%", height: "21%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "50%" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "20%", height: "21%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: { type: "input", height: "50%" }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "default",
                fn: function() {
                  return [
                    _c("b-form", [
                      _c(
                        "div",
                        { staticClass: "custom-collapse-group" },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName:
                                    "v-b-toggle.collapse-organization-details",
                                  modifiers: {
                                    "collapse-organization-details": true
                                  }
                                }
                              ],
                              staticClass: "custom-collapse-header",
                              attrs: { role: "button" }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "chevron-icon",
                                attrs: {
                                  name: "buttons/collapse_chevrons_down",
                                  size: 13
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "custom-collapse-header-title" },
                                [_vm._v("Реквизиты компании")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              attrs: {
                                id: "collapse-organization-details",
                                visible: ""
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "custom-collapse-body" },
                                [
                                  _c(
                                    "b-row",
                                    { attrs: { cols: "3" } },
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-inn",
                                                label: _vm.$t(
                                                  "message.organizations.modal.inn"
                                                )
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  disabled: _vm.isDisabled,
                                                  state: _vm.getFieldState(
                                                    "inn"
                                                  ),
                                                  placeholder: "Введите ИНН"
                                                },
                                                model: {
                                                  value: _vm.newItem.inn,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "inn",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.inn"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-kpp",
                                                label: _vm.$t(
                                                  "message.organizations.modal.kpp"
                                                )
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  disabled: _vm.isDisabled,
                                                  placeholder: "Введите КПП"
                                                },
                                                model: {
                                                  value: _vm.newItem.kpp,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "kpp",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.kpp"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-ogrn",
                                                label: _vm.$t(
                                                  "message.organizations.modal.ogrn"
                                                )
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  disabled: _vm.isDisabled,
                                                  placeholder: "Введите ОГРН"
                                                },
                                                model: {
                                                  value: _vm.newItem.ogrn,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "ogrn",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.ogrn"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass:
                                        "custom-btn-secondary mb-2 mt-1",
                                      attrs: {
                                        disabled:
                                          _vm.isEmpty(_vm.newItem.inn) ||
                                          _vm.isDisabled ||
                                          _vm.isLookingUpParty
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.findCustomerData()
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", {
                                        attrs: {
                                          name: "buttons/fill",
                                          size: 13
                                        }
                                      }),
                                      _vm._v(
                                        "\n                  Заполнить данными\n                "
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "8" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Полное наименование"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value: _vm.newItem.full_name,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "full_name",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.full_name"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label:
                                                  "Сокращённое наименование"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  disabled: _vm.isDisabled,
                                                  state: _vm.getFieldState(
                                                    "name"
                                                  )
                                                },
                                                model: {
                                                  value: _vm.newItem.name,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "name",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.name"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "8" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Юридический адрес"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "text",
                                                  size: "sm",
                                                  disabled: _vm.isDisabled,
                                                  placeholder: _vm.$t(
                                                    "message.organizations.modal.addressPlaceholder"
                                                  )
                                                },
                                                model: {
                                                  value: _vm.newItem.address,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "address",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.address"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                label: "Контактный телефон"
                                              }
                                            },
                                            [
                                              _c(
                                                "b-input-group",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    prepend: _vm.phoneInputPrefix(
                                                      _vm.newItem.phone
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      type: "tel",
                                                      size: "sm",
                                                      disabled: _vm.isDisabled,
                                                      placeholder: _vm.$t(
                                                        "message.organizations.modal.phonePlaceholder"
                                                      )
                                                    },
                                                    model: {
                                                      value: _vm.newItem.phone,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newItem,
                                                          "phone",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "newItem.phone"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Описание" } },
                                    [
                                      _c("b-form-textarea", {
                                        attrs: {
                                          size: "sm",
                                          disabled: _vm.isDisabled,
                                          placeholder: _vm.$t(
                                            "message.organizations.modal.descriptionPlaceholder"
                                          ),
                                          rows: 3,
                                          "max-rows": 6
                                        },
                                        model: {
                                          value: _vm.newItem.description,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.newItem,
                                              "description",
                                              $$v
                                            )
                                          },
                                          expression: "newItem.description"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "custom-collapse-group" },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName:
                                    "v-b-toggle.collapse-organization-bank-details",
                                  modifiers: {
                                    "collapse-organization-bank-details": true
                                  }
                                }
                              ],
                              staticClass: "custom-collapse-header",
                              attrs: { role: "button" }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "chevron-icon",
                                attrs: {
                                  name: "buttons/collapse_chevrons_down",
                                  size: 13
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "custom-collapse-header-title" },
                                [_vm._v("Банковские реквизиты")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              attrs: {
                                id: "collapse-organization-bank-details",
                                visible: ""
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "custom-collapse-body" },
                                [
                                  _c(
                                    "b-row",
                                    {
                                      staticClass: "align-items-end",
                                      attrs: { cols: "2" }
                                    },
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-bik",
                                                label: _vm.$t(
                                                  "message.organizations.modal.bik"
                                                )
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  autocomplete: "off",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value: _vm.newItem.bik,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "bik",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.bik"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-cor-account",
                                                label: _vm.$t(
                                                  "message.organizations.modal.cor_account"
                                                )
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  autocomplete: "off",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem.cor_account,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "cor_account",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.cor_account"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-bank",
                                                label: _vm.$t(
                                                  "message.organizations.modal.bank"
                                                )
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "input-bank",
                                                  size: "sm",
                                                  autocomplete: "off",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value: _vm.newItem.bank,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "bank",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.bank"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-checking-account",
                                                label: _vm.$t(
                                                  "message.organizations.modal.checking_account"
                                                )
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "input-checking-account",
                                                  size: "sm",
                                                  autocomplete: "off",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.newItem
                                                      .checking_account,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "checking_account",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.checking_account"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "custom-collapse-group" },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName:
                                    "v-b-toggle.collapse-organization-executive",
                                  modifiers: {
                                    "collapse-organization-executive": true
                                  }
                                }
                              ],
                              staticClass: "custom-collapse-header",
                              attrs: { role: "button" }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "chevron-icon",
                                attrs: {
                                  name: "buttons/collapse_chevrons_down",
                                  size: 13
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "custom-collapse-header-title" },
                                [
                                  _vm._v(
                                    "Руководители организации или ИП для документов"
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              attrs: {
                                id: "collapse-organization-executive",
                                visible: ""
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "custom-collapse-body" },
                                [
                                  _c(
                                    "b-row",
                                    {
                                      staticClass: "align-items-end",
                                      attrs: { cols: "2" }
                                    },
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-director",
                                                label: _vm.$t(
                                                  "message.organizations.modal.director"
                                                )
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  autocomplete: "off",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value: _vm.newItem.director,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "director",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.director"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-accountant",
                                                label: _vm.$t(
                                                  "message.organizations.modal.accountant"
                                                )
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  autocomplete: "off",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value: _vm.newItem.accountant,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "accountant",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.accountant"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "custom-collapse-group" },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName:
                                    "v-b-toggle.collapse-organization-integrations",
                                  modifiers: {
                                    "collapse-organization-integrations": true
                                  }
                                }
                              ],
                              staticClass: "custom-collapse-header",
                              attrs: { role: "button" }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "chevron-icon",
                                attrs: {
                                  name: "buttons/collapse_chevrons_down",
                                  size: 13
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "custom-collapse-header-title" },
                                [_vm._v("Интеграции")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              attrs: {
                                id: "collapse-organization-integrations",
                                visible: ""
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "custom-collapse-body" },
                                [
                                  _c(
                                    "b-row",
                                    { staticClass: "align-items-end" },
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-balans-pro",
                                                label: "Баланс Про API токен"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "password",
                                                  size: "sm",
                                                  autocomplete: "off",
                                                  disabled: _vm.isDisabled,
                                                  placeholder: _vm.integrations
                                                    .balans_pro_configured
                                                    ? "Токен сохранён"
                                                    : ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.integrations
                                                      .balans_pro_org_token,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.integrations,
                                                      "balans_pro_org_token",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "integrations.balans_pro_org_token"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-avito-client-id",
                                                label: "Авито Client id"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  size: "sm",
                                                  autocomplete: "off",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value:
                                                    _vm.integrations
                                                      .avito_client_id,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.integrations,
                                                      "avito_client_id",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "integrations.avito_client_id"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-avito-client-secret",
                                                label: "Авито Client secret"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  type: "password",
                                                  size: "sm",
                                                  autocomplete: "off",
                                                  disabled: _vm.isDisabled,
                                                  placeholder: _vm.integrations
                                                    .avito_configured
                                                    ? "Секрет сохранён"
                                                    : ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.integrations
                                                      .avito_client_secret,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.integrations,
                                                      "avito_client_secret",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "integrations.avito_client_secret"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "custom-collapse-group" },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName:
                                    "v-b-toggle.collapse-organization-signatures",
                                  modifiers: {
                                    "collapse-organization-signatures": true
                                  }
                                }
                              ],
                              staticClass: "custom-collapse-header",
                              attrs: { role: "button" }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "chevron-icon",
                                attrs: {
                                  name: "buttons/collapse_chevrons_down",
                                  size: 13
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "custom-collapse-header-title" },
                                [_vm._v("Логотип, печать и подписи")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              attrs: {
                                id: "collapse-organization-signatures",
                                visible: ""
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "custom-collapse-body" },
                                [
                                  _c(
                                    "b-tabs",
                                    {
                                      staticClass: "custom-tabs",
                                      attrs: { card: "" }
                                    },
                                    [
                                      _c(
                                        "b-tab",
                                        {
                                          attrs: {
                                            active: "",
                                            title: "Логотип"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "upload-zone",
                                              class: {
                                                "is-muted": !!_vm.logoFile
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "upload-main-content"
                                                },
                                                [
                                                  _c("v-icon", {
                                                    attrs: {
                                                      name: "buttons/inbox",
                                                      size: 32
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-column ml-2"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold text-dark"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Перетяните файлы в эту область"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-muted"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "или нажмите, чтобы выбрать файл"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "upload-meta" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-column text-right leading-tight"
                                                    },
                                                    [
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-muted",
                                                          staticStyle: {
                                                            "font-size": "12px"
                                                          }
                                                        },
                                                        [_vm._v("РАЗМЕР, ММ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-muted"
                                                        },
                                                        [_vm._v("54х27")]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.logoFile
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "upload-preview-container"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "preview-frame"
                                                            },
                                                            [
                                                              _c("img", {
                                                                staticClass:
                                                                  "preview-img",
                                                                attrs: {
                                                                  src:
                                                                    _vm.logoBlobURL,
                                                                  alt: "Preview"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c("v-icon", {
                                                                staticClass:
                                                                  "delete-icon ml-2",
                                                                attrs: {
                                                                  name:
                                                                    "buttons/trash",
                                                                  size: 20
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.onRemove(
                                                                      "logoFile"
                                                                    )
                                                                  }
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("b-form-file", {
                                                staticClass:
                                                  "hidden-file-input",
                                                attrs: {
                                                  plain: "",
                                                  accept:
                                                    "image/jpeg, image/png",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value: _vm.logoFile,
                                                  callback: function($$v) {
                                                    _vm.logoFile = $$v
                                                  },
                                                  expression: "logoFile"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tab",
                                        { attrs: { title: "Печать" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "upload-zone",
                                              class: {
                                                "is-muted": !!_vm.stampFile
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "upload-main-content"
                                                },
                                                [
                                                  _c("v-icon", {
                                                    attrs: {
                                                      name: "buttons/inbox",
                                                      size: 32
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-column ml-2"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold text-dark"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Перетяните файлы в эту область"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-muted"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "или нажмите, чтобы выбрать файл"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "upload-meta" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-column text-right leading-tight"
                                                    },
                                                    [
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-muted",
                                                          staticStyle: {
                                                            "font-size": "12px"
                                                          }
                                                        },
                                                        [_vm._v("РАЗМЕР, ММ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-muted"
                                                        },
                                                        [_vm._v("40x40")]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.stampFile
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "upload-preview-container"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "preview-frame"
                                                            },
                                                            [
                                                              _c("img", {
                                                                staticClass:
                                                                  "preview-img",
                                                                attrs: {
                                                                  src:
                                                                    _vm.stampBlobURL,
                                                                  alt: "Preview"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c("v-icon", {
                                                                staticClass:
                                                                  "delete-icon ml-2",
                                                                attrs: {
                                                                  name:
                                                                    "buttons/trash",
                                                                  size: 20
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.onRemove(
                                                                      "stampFile"
                                                                    )
                                                                  }
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("b-form-file", {
                                                staticClass:
                                                  "hidden-file-input",
                                                attrs: {
                                                  plain: "",
                                                  accept:
                                                    "image/jpeg, image/png",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value: _vm.stampFile,
                                                  callback: function($$v) {
                                                    _vm.stampFile = $$v
                                                  },
                                                  expression: "stampFile"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tab",
                                        {
                                          attrs: {
                                            title: "Подпись руководителя"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "upload-zone",
                                              class: {
                                                "is-muted": !!_vm.directorSignFile
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "upload-main-content"
                                                },
                                                [
                                                  _c("v-icon", {
                                                    attrs: {
                                                      name: "buttons/inbox",
                                                      size: 32
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-column ml-2"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold text-dark"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Перетяните файлы в эту область"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-muted"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "или нажмите, чтобы выбрать файл"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "upload-meta" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-column text-right leading-tight"
                                                    },
                                                    [
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-muted",
                                                          staticStyle: {
                                                            "font-size": "12px"
                                                          }
                                                        },
                                                        [_vm._v("РАЗМЕР, ММ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-muted"
                                                        },
                                                        [_vm._v("34x16")]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.directorSignFile
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "upload-preview-container"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "preview-frame"
                                                            },
                                                            [
                                                              _c("img", {
                                                                staticClass:
                                                                  "preview-img",
                                                                attrs: {
                                                                  src:
                                                                    _vm.directorSignBlobURL,
                                                                  alt: "Preview"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c("v-icon", {
                                                                staticClass:
                                                                  "delete-icon ml-2",
                                                                attrs: {
                                                                  name:
                                                                    "buttons/trash",
                                                                  size: 20
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.onRemove(
                                                                      "stampFile"
                                                                    )
                                                                  }
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("b-form-file", {
                                                staticClass:
                                                  "hidden-file-input",
                                                attrs: {
                                                  plain: "",
                                                  accept:
                                                    "image/jpeg, image/png",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value: _vm.directorSignFile,
                                                  callback: function($$v) {
                                                    _vm.directorSignFile = $$v
                                                  },
                                                  expression: "directorSignFile"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tab",
                                        {
                                          attrs: { title: "Подпись бухгалтера" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "upload-zone",
                                              class: {
                                                "is-muted": !!_vm.accountantSignFile
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "upload-main-content"
                                                },
                                                [
                                                  _c("v-icon", {
                                                    attrs: {
                                                      name: "buttons/inbox",
                                                      size: 32
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-column ml-2"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold text-dark"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Перетяните файлы в эту область"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-muted"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "или нажмите, чтобы выбрать файл"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "upload-meta" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-column text-right leading-tight"
                                                    },
                                                    [
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-muted",
                                                          staticStyle: {
                                                            "font-size": "12px"
                                                          }
                                                        },
                                                        [_vm._v("РАЗМЕР, ММ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-muted"
                                                        },
                                                        [_vm._v("34x16")]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.accountantSignFile
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "upload-preview-container"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "preview-frame"
                                                            },
                                                            [
                                                              _c("img", {
                                                                staticClass:
                                                                  "preview-img",
                                                                attrs: {
                                                                  src:
                                                                    _vm.accountantSignBlobURL,
                                                                  alt: "Preview"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c("v-icon", {
                                                                staticClass:
                                                                  "delete-icon ml-2",
                                                                attrs: {
                                                                  name:
                                                                    "buttons/trash",
                                                                  size: 20
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.onRemove(
                                                                      "stampFile"
                                                                    )
                                                                  }
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("b-form-file", {
                                                staticClass:
                                                  "hidden-file-input",
                                                attrs: {
                                                  plain: "",
                                                  accept:
                                                    "image/jpeg, image/png",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value: _vm.accountantSignFile,
                                                  callback: function($$v) {
                                                    _vm.accountantSignFile = $$v
                                                  },
                                                  expression:
                                                    "accountantSignFile"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tab",
                                        { attrs: { title: "Подпись ИП" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "upload-zone",
                                              class: {
                                                "is-muted": !!_vm.individualSignFile
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "upload-main-content"
                                                },
                                                [
                                                  _c("v-icon", {
                                                    attrs: {
                                                      name: "buttons/inbox",
                                                      size: 32
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-column ml-2"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold text-dark"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Перетяните файлы в эту область"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-muted"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "или нажмите, чтобы выбрать файл"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "upload-meta" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-column text-right leading-tight"
                                                    },
                                                    [
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-muted",
                                                          staticStyle: {
                                                            "font-size": "12px"
                                                          }
                                                        },
                                                        [_vm._v("РАЗМЕР, ММ")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-muted"
                                                        },
                                                        [_vm._v("34x16")]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.individualSignFile
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "upload-preview-container"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "preview-frame"
                                                            },
                                                            [
                                                              _c("img", {
                                                                staticClass:
                                                                  "preview-img",
                                                                attrs: {
                                                                  src:
                                                                    _vm.individualSignBlobURL,
                                                                  alt: "Preview"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c("v-icon", {
                                                                staticClass:
                                                                  "delete-icon ml-2",
                                                                attrs: {
                                                                  name:
                                                                    "buttons/trash",
                                                                  size: 20
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.onRemove(
                                                                      "stampFile"
                                                                    )
                                                                  }
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("b-form-file", {
                                                staticClass:
                                                  "hidden-file-input",
                                                attrs: {
                                                  plain: "",
                                                  accept:
                                                    "image/jpeg, image/png",
                                                  disabled: _vm.isDisabled
                                                },
                                                model: {
                                                  value: _vm.individualSignFile,
                                                  callback: function($$v) {
                                                    _vm.individualSignFile = $$v
                                                  },
                                                  expression:
                                                    "individualSignFile"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2af072dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2af072dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Organizations/Organization.vue
// module id = null
// module chunks = 